module.exports = __webpack_public_path__ + "static/media/CV.c4732d38.png";